import PropTypes from "prop-types"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const ItemTitle = ({ className = "", ...props }) => (
  <h2 className={cn("body-lg mb-8 pr-40 font-bold", className)} {...props} />
)

export const ItemAction = ({ className = "", ...props }) => (
  <Button
    className={cn("text-14 font-medium", className)}
    text
    underline
    variant="secondary"
    {...props}
  />
)
ItemAction.propTypes = {
  className: PropTypes.string,
}

export const TitleDivider = ({ className = "", ...props }) => (
  <div
    className={cn(
      "before:border-grey-20 after:border-grey-20 tablet:before:border-0 tablet:after:border-0 tablet:before:flex-none tablet:before:mr-0 flex items-center before:mr-10 before:flex-1 before:border-b after:ml-10 after:flex-1 after:border-b",
      className
    )}
    {...props}
  />
)

export const MainContainer = ({ className = "", ...props }) => (
  <div
    className={cn(
      "tablet:gap-16 desktop:flex-1 flex flex-col gap-24",
      className
    )}
    {...props}
  />
)

export const SidePanelWrapper = ({ className = "", ...props }) => (
  <div
    className={cn(
      "desktop:h-full desktop:sticky desktop:top-24 desktop:w-1/3 w-full",
      className
    )}
    {...props}
  />
)

export const Panel = ({ className = "", ...props }) => (
  <div
    className={cn(
      "tablet:px-24 tablet:border tablet:border-solid tablet:mb-16 tablet:mx-0 border-grey-20 -mx-16 border-none bg-white px-16 py-24",
      className
    )}
    {...props}
  />
)

export const LineItemCard = ({ className = "", isProduct, ...props }) => (
  <div
    className={cn(
      "border-grey-20 desktop:px-12 border bg-white px-10 py-20",
      isProduct ? "desktop:pb-8 desktop:pt-24" : "desktop:py-24",
      className
    )}
    {...props}
  />
)

export const LinkButton = ({ className = "", ...props }) => (
  <Button
    className={cn(
      "text-14 leading-20 tablet:font-light mx-auto flex w-fit font-medium tracking-tight",
      className
    )}
    text
    underline
    variant="secondary"
    {...props}
  />
)

ItemTitle.propTypes = {
  className: PropTypes.string,
}
ItemAction.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}
TitleDivider.propTypes = {
  className: PropTypes.string,
}
MainContainer.propTypes = {
  className: PropTypes.string,
}
LinkButton.propTypes = {
  className: PropTypes.string,
}
LineItemCard.propTypes = {
  className: PropTypes.string,
  isProduct: PropTypes.bool,
}
Panel.propTypes = {
  className: PropTypes.string,
}
SidePanelWrapper.propTypes = {
  className: PropTypes.string,
}
